import React from "react";
import CommonSelect from "../../../components/forms/CommonSelect";

function SolicitacaoCobrancaSwalHtml() {
  return (
    <div className="row justify-content-center" style={{ width: "99%" }}>
      <div className="col-md-8">
        <CommonSelect
          label="Justificativa"
          id="justificativa"
          data={[
            { id: 1, text: "A pedido do cliente" },
            { id: 2, text: "Substituição" },
            { id: 3, text: "Pago direto ao cliente" },
          ]}
          placeholder="Selecione uma justificativa"
        />
      </div>
    </div>
  );
}

export default SolicitacaoCobrancaSwalHtml;
